import { createContext } from "react";

import { INotificationsContext } from "../interfaces-and-types";

export const NotificationsContext = createContext<INotificationsContext>({
  notification: null,
  showNotification: () => {},
  clearNotifications: () => {},
});
